export default __webpack_public_path__ + "assets/Background.1bf0.jpg";